import { Component, OnInit, Inject, ViewChild, ElementRef } from '@angular/core';
import { IssueInfo } from '../model/issue.model';
import { ProjectInfo } from '../model/project.model';
import { EmpInfo } from '../model/emp.model';
import { ProjectMemberInfo } from '../model/projectmember.model';
import { TeamInfo } from '../model/team.model';
import { LookupInfo } from '../model/lookup.model';
import { RoleInfo } from '../model/role.model';

import {
  HttpClient,
  HttpHeaders
} from "@angular/common/http";
import {
  environment
} from 'src/environments/environment';
import { CompanyInfo } from '../model/company.model';
import { ActivatedRoute } from '@angular/router';
import { TokenService } from '../service/token.service';
/*import { Observable } from 'rxjs';*/
import { Observable, Subscription } from 'rxjs';
import { GlobalService } from '../service/global.service';
import { PositionLevelInfo } from '../model/PositionManagementInfo.model';
import { Router } from '@angular/router';

@Component({
  selector: 'app-user-profile',
  templateUrl: './user-profile.component.html',
  styleUrls: ['./user-profile.component.css']
})
export class UserProfileComponent implements OnInit {

  @ViewChild('fileUploader') fileUploader: ElementRef;

  EmpOnPromise: Promise<EmpInfo[]>
  empList: EmpInfo[] = [];

  ProjectEmpOnPromise: Promise<ProjectMemberInfo[]>
  projectEmpList: ProjectMemberInfo[] = [];

  LookupPromise: Promise<LookupInfo[]>
  TitleList: LookupInfo[] = [];
  PositionList: PositionLevelInfo[] = [];
  EmpTypeList: LookupInfo[] = [];
  TeamList: TeamInfo[] = [];
  RoleList: RoleInfo[] = [];
  CompanyList: CompanyInfo[] = [];
  GenderList: LookupInfo[] = [];

  isSearchSubmitted: boolean = false;
  txtSearchEmpCode: string
  txtSearchEmpName_TH: string
  txtSearchCompany: string

  txtEmpCode: string
  txtExEmpCode: string
  txtEmpEmail: string
  txtEmpImg: string
  hidTitleCode: string
  txtEmpNickName_TH: string
  txtEmpFName_TH: string
  txtEmpLName_TH: string
  txtEmpFName_EN: string
  txtEmpLName_EN: string
  hidPositionCode: number
  hidEmpType: string
  hidTeamCode: string
  hidRoleCode: string
  ddlCompany: string = null
  hidEmpId: number
  ddlEmpGender: string = "";
  birthDate: string;
  entryDate: string;
  txtEmpTel: string;

  isOnUpdate: boolean;
  isSubmitted: any;

  ShowMail: string;

  externalType: string = '2';
  internalType: string = '1';

  // Org Chat
  filesToUpload: File[] = [];
  pathImg: string;

  resultUploadfile: any;

  //Pagination variable
  public currentPageNumber: number
  public EmpTotal: any
  public totalPages: number
  public environment: number

  element: HTMLElement;
  public hidcouchk: string;
  public hidcouchks: string;
  baseurl: string;

  _ForK2: string;
  _EmpCode: string;
  _EmpMail: string;

  _ParamEmpCode: string;
  _ParamEmail: string;

  getTokenUrl: string;

  //Modal
  titlemodal: string;
  detailmodal: string;

  constructor(private httpClient: HttpClient, @Inject('BASE_URL') baseUrl: string, private activatedRoute: ActivatedRoute, private TokenService: TokenService, private GlobalService: GlobalService, private routers: Router) {
    this.baseurl = environment.base_api;

    this._ForK2 = this.activatedRoute.snapshot.params.ForK2;
    //this._EmpCode = this.activatedRoute.snapshot.params.EmpCode;
    this._EmpCode = localStorage.getItem("EmpCode");

    //GlobalService.CheckPagingAccessRights();

  }


  async ngOnInit() {
    
    $(document).ready(function () {
      $('#InsertSectionEmp').css('display', 'none'); 
    });

    //Set param
    this.activatedRoute.params.subscribe(params => {
      this._ParamEmpCode = params['EmpCode'];
      /*console.log("this._ParamEmail: ", this._ParamEmail);*/
      //this.Email = params['Email'];
    });

    this.currentPageNumber = 1;
    this.environment = environment.PageSize;

    this.loadDdlTitle()
    this.LoadEmp()
    this.loadDdlPosition()
    this.loadDdlEmpType()
    this.loadDdlTeam()
    this.loadDdlRole()
    this.loadddlCompany()
    this.loadGenderList();
    this.hidTitleCode = null
    this.hidPositionCode = 0
    this.hidEmpType = null
    this.hidTeamCode = null
    this.hidRoleCode = null


    this.LoadEmp();
    this.LoadProjectEmp();

    this.resultUploadfile = { type: null };
    this.pathImg = "";
  }
  ///////////////////////////////////////Events////////////////////////////////////////////
  btnClick_showEmpList() {
    this.isSearchSubmitted = true;
    this.LoadEmp()
  }

  btnClick_onInsertEmp() {
    this.clearInsertSection();
    $('#InsertSectionEmp').css('display', 'block'); 
    this.isOnUpdate = false
  }

  btnClick_onUpdateEmp(id) {
    $('#InsertSectionEmp').css('display', 'block');
    document.getElementById("AddEditEmployee").scrollIntoView(); 
    this.isOnUpdate = true
  

    let index = this.empList.findIndex(x => x.Id == id);
    this.hidEmpId = this.empList[index].Id
    
    //Company Info
    this.ddlCompany = this.empList[index].CompanyCode != null ? this.empList[index].CompanyCode : null
    this.hidEmpType = this.empList[index].EmpType != null ? this.empList[index].EmpType : null
    this.txtEmpCode = this.empList[index].EmpCode
    this.txtExEmpCode = this.empList[index].EmpCode

    var d = new Date(this.empList[index].EntryDate);
    this.entryDate = d.toLocaleDateString('en-CA');

    //Personal Info
    this.hidTitleCode = this.empList[index].Title_EN != null ? this.empList[index].Title_EN : null
    this.txtEmpNickName_TH = this.empList[index].NickName
    this.txtEmpFName_TH = this.empList[index].EmpFname_TH
    this.txtEmpLName_TH = this.empList[index].EmpLname_TH
    this.txtEmpFName_EN = this.empList[index].EmpFname_EN
    this.txtEmpLName_EN = this.empList[index].EmpLname_EN
    this.birthDate = new Date(this.empList[index].BirthDate).toLocaleDateString('en-CA');
    this.ddlEmpGender = !!this.empList[index].Gender ? this.empList[index].Gender.toString() : "";
    this.txtEmpEmail = this.empList[index].Mail;
    this.txtEmpTel = this.empList[index].Mobile;
    //this.pathImg = this.empList[index].ImgProfile != null ? this.empList[index].ImgProfile : null
    this.pathImg = this.empList[index].ImgProfile != null ? this.empList[index].ImgProfile : null;

    if (this.pathImg != null) {
      $('#previewImg').show();
    } else {
      $('#previewImg').hide();

    }
    
    //Role/Position
    this.hidRoleCode = this.empList[index].RoleCode != null ? this.empList[index].RoleCode : null
    this.hidTeamCode = this.empList[index].TeamCode != null ? this.empList[index].TeamCode : null
    this.hidPositionCode = this.empList[index].PositionCode != null ? Number(this.empList[index].PositionCode) : null
    
  }

  async btnClick_deleteEmp(id) {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };
      let strjsonCusInfo = "{EmpCode: " + id + "}";

      if (confirm("Are you sure you want to delete this employee?")) {
        this.isSubmitted = this.httpClient.post<EmpInfo[]>(this.baseurl + "Employee/DeleteEmployeeList", strjsonCusInfo, httpOptions)
          .subscribe(result => this.isSubmitted = result, failCb => {
            console.log("Update fail")
          },
            () => {
              console.log("Update = " + this.isSubmitted)
              this.clearInsertSection()

              //Inform user
              this.titlemodal = '';
              this.detailmodal = 'Employee information has been deleted successfully.';
              $('#ModalComplate .modal-header').text('Information');
              $('#ModalComplate .modal-header').addClass('bg-gold');
              $('#ModalComplate').modal();

              this.LoadEmp()
            }
          )
      }
    }

  }

  async uploadImg() {
    
    if (this.filesToUpload != undefined) {
      if (this.filesToUpload.length > 0) {
        var tragetfile = this.filesToUpload[0];
        var filename = tragetfile.name;
        const formData = new FormData();
        formData.append("pathfile", "ClientApp/dist/assets/Image/Profile");
        formData.append('file', tragetfile, filename);

        this.resultUploadfile = await this.httpClient.post(this.baseurl + "api/upload", formData, { reportProgress: true, observe: 'events' })
          .toPromise();
      }
    }

  }

  async btnClick_submitInsertEmp() {
    
    $('#InsertSectionEmp').css('display', 'block'); 
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      this.txtExEmpCode = this.EmpTotal + 1;
      if (this.txtEmpCode == null || this.txtEmpCode == '') {

        let objData = {};
        objData["CompanyCode"] = this.ddlCompany;
        objData["EmpType"] = this.hidEmpType;
        objData["EmpCode"] = this.ddlCompany + "0" + this.txtExEmpCode;
        objData["EntryDate"] = this.entryDate;

        objData["Title_TH"] = this.hidTitleCode;
        objData["Title_EN"] = this.hidTitleCode;
        objData["NickName"] = this.txtEmpNickName_TH;
        objData["EmpFname_TH"] = this.txtEmpFName_TH;
        objData["EmpLname_TH"] = this.txtEmpLName_TH;
        objData["EmpFname_EN"] = this.txtEmpFName_EN;
        objData["EmpLname_EN"] = this.txtEmpLName_EN;
        objData["BirthDate"] = this.birthDate;
        objData["Mail"] = this.txtEmpEmail;
        objData["Mobile"] = this.txtEmpTel;
        objData["Gender"] = !!this.ddlEmpGender ? this.ddlEmpGender : $('#ddlEmpGender').val();

        objData["RoleCode"] = this.hidRoleCode;
        objData["PositionCode"] = this.hidPositionCode;
        objData["TeamCode"] = this.hidTeamCode;
        //objData["ImgProfile"] = this.pathImg;
        objData["ImgProfile"] = this.checkUndefinedString(this.pathImg);
        objData["FlagDelete"] = "N";

        let strjson = JSON.stringify(objData);

        this.isSubmitted = this.httpClient.post<EmpInfo[]>(this.baseurl + "Employee/InsertEmployee", strjson, httpOptions)

          .subscribe(result => this.isSubmitted = result, failCb => {
            console.log("Insert fail")
          },
            () => {
              console.log("Insert = " + this.isSubmitted)
              this.clearInsertSection()
              $('#InsertSectionEmp').css('display', 'none'); 
              //this.AuthorizeUser(this.ddlCompany + "0" + this.txtExEmpCode);

              //Inform user
              this.titlemodal = '';
              this.detailmodal = 'User information has been created successfully.';
              $('#ModalComplate .modal-header').text('Information');
              $('#ModalComplate .modal-header').addClass('bg-gold');
              $('#ModalComplate').modal();

              this.LoadEmp()
            }
          )
      }
      else {

        let objData = {};
        objData["CompanyCode"] = this.ddlCompany;
        objData["EmpType"] = this.hidEmpType;
        objData["EmpCode"] = this.txtEmpCode;
        objData["EntryDate"] = this.entryDate;

        objData["Title_TH"] = this.hidTitleCode;
        objData["Title_EN"] = this.hidTitleCode;
        objData["NickName"] = this.txtEmpNickName_TH;
        objData["EmpFname_TH"] = this.txtEmpFName_TH;
        objData["EmpLname_TH"] = this.txtEmpLName_TH;
        objData["EmpFname_EN"] = this.txtEmpFName_EN;
        objData["EmpLname_EN"] = this.txtEmpLName_EN;
        objData["BirthDate"] = this.birthDate;
        objData["Mail"] = this.txtEmpEmail;
        objData["Mobile"] = this.txtEmpTel;
        objData["Gender"] = !!this.ddlEmpGender ? this.ddlEmpGender : $('#ddlEmpGender').val();

        objData["RoleCode"] = this.hidRoleCode;
        objData["PositionCode"] = this.hidPositionCode;
        objData["TeamCode"] = this.hidTeamCode;
        objData["ImgProfile"] = this.checkUndefinedString(this.pathImg);
        //objData["ImgProfile"] = this.pathImg;
        objData["FlagDelete"] = "N";

        
        let strjson = JSON.stringify(objData);

        this.isSubmitted = this.httpClient.post<EmpInfo[]>(this.baseurl + "Employee/InsertEmployee", strjson, httpOptions)

          .subscribe(result => this.isSubmitted = result, failCb => {
            console.log("Insert fail")
          },
            () => {
              console.log("Insert = " + this.isSubmitted)
              this.clearInsertSection()
              
              $('#InsertSectionEmp').css('display', 'none'); 
              //this.AuthorizeUser(this.txtEmpCode);

              this.LoadEmp()
              //this.uploadImg()
            }
          )
      }
    }

  }

  
  btnClick_submitUpdateEmp(id) {
    $('#ModalConfirmChanges').modal();
  }

  async confirmSaveChanges() {
    $('#ModalConfirmChanges').modal('hide');
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      
      $('#InsertSectionEmp').css('display', 'block'); 
      var id = this.hidEmpId
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };


      if (this.txtEmpCode == undefined || this.txtEmpCode == null || this.txtEmpCode == '') {
        alert("กรุณากรอกข้อมูลให้ครบถ้วน");
      }
      else {

        let objData = {};
        objData["EmpId"] = id;

        objData["CompanyCode"] = this.ddlCompany;
        objData["EmpType"] = this.hidEmpType;
        objData["EmpCode"] = this.txtEmpCode;
        objData["EntryDate"] = this.entryDate;

        objData["Title_TH"] = this.hidTitleCode;
        objData["Title_EN"] = this.hidTitleCode;
        objData["NickName"] = this.txtEmpNickName_TH;
        objData["EmpFname_TH"] = this.txtEmpFName_TH;
        objData["EmpLname_TH"] = this.txtEmpLName_TH;
        objData["EmpFname_EN"] = this.txtEmpFName_EN;
        objData["EmpLname_EN"] = this.txtEmpLName_EN;
        objData["BirthDate"] = this.birthDate;
        objData["Mail"] = this.txtEmpEmail;
        objData["Mobile"] = this.txtEmpTel;
        objData["Gender"] = !!this.ddlEmpGender ? this.ddlEmpGender : $('#ddlEmpGender').val();

        objData["RoleCode"] = this.hidRoleCode;
        objData["PositionCode"] = this.hidPositionCode;
        objData["TeamCode"] = this.hidTeamCode;

        objData["FlagDelete"] = "N";
        objData["ImgProfile"] = this.checkUndefinedString(this.pathImg);
        ////if (this.fileUploader.nativeElement.value == null) {
        ////  objData["ImgProfile"] = null;
        ////} else {
        //  objData["ImgProfile"] = this.pathImg;
        ////}

        let strjson = JSON.stringify(objData);

        this.isSubmitted = this.httpClient.post<EmpInfo[]>(this.baseurl + "Employee/UpdateEmployee", strjson, httpOptions)

          .subscribe(result => this.isSubmitted = result, failCb => {
            console.log("Update fail")
          },
            () => {
              console.log("Update = " + this.isSubmitted)
              this.clearInsertSection()
              $('#InsertSectionEmp').css('display', 'none'); 

              //Inform user
              this.titlemodal = '';
              this.detailmodal = 'User information has been updated successfully.';
              $('#ModalComplate .modal-header').text('Information');
              $('#ModalComplate .modal-header').addClass('bg-gold');
              $('#ModalComplate').modal();

              //Load new data
              this.LoadEmp()
              //this.uploadImg()

            }
          )
      }
    }
  }

  chkallclick() {
    for (var i = 0; i <= 100; i++) {
      this.element = document.getElementById('chk' + i) as HTMLElement;
      this.element.click();
    }
  }

  async btnClick_onDeleteEmp() {
    let num = parseInt(this.hidcouchk);
    for (var i = 0; i < num; i++) {
      var element = <HTMLInputElement>document.getElementById('chk' + i);
      var isChecked = element.checked;

      var element2 = <HTMLInputElement>document.getElementById('Id' + i);

      if (isChecked) {
        await this.btnClick_deleteEmp(parseInt(element2.value));
      }
    }
    this.LoadEmp();
  }

  btnClick_AuthorizeUser(EmpCode) {
    this.AuthorizeUser(EmpCode);
  }
  ///////////////////////////////////////Functions/////////////////////////////////////////

  btnClick_selectFile(traget) {
    var file = $(traget.currentTarget).parents().find(".file");
    file.trigger("click");
  }

  selectFileOnChange(ss) {
    const fi = document.getElementById('fileimage');
    const fsize = ss.currentTarget.files[0].size;
    const file = Math.round((fsize / 1024));
    
    var fileName = ss.currentTarget.files[0].name;
    this.filesToUpload = ss.currentTarget.files;
    $("#file").val(fileName);
    const reader = new FileReader();
    reader.onload = () => {
      this.pathImg = reader.result as string;
    }
    // The size of the file.
    if (file >= 250) {
      alert(
        "File exceeds the maximum size 200KB");
      $('#previewImg').hide();
    } else if (file < 200) {
      //alert(
      //  "File too small, please select a file greater than 2mb");
      // read the image file as a data URL.
      reader.readAsDataURL(ss.currentTarget.files[0]);
      $('#previewImg').show();
    }
    
  }

  resetFileUploader() {
    this.fileUploader.nativeElement.value = null;
    this.pathImg == null;
    $('#previewImg').hide();

  }

  LoadProjectEmp() {
    this.LoadProjectEmpList()
      .then(
        data => {
          this.projectEmpList = data
          this.hidcouchks = this.projectEmpList.length.toString();
        }
      )
      //.then(() => {
      //  this.CountProjectEmpList()
      //})
  }

  async LoadProjectEmpList(): Promise<ProjectMemberInfo[]> {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      let offset = (this.currentPageNumber - 1) * environment.PageSize;

      var objectjson = {};
      objectjson['EmpCode'] = this._EmpCode;
      //objectjson['EmpName_TH'] = this.checkUndefinedString(this.txtSearchEmpName_TH);
      //objectjson['CompanyCode'] = this.checkUndefinedString(this.txtSearchCompany);
      //objectjson['rowFetch'] = environment.PageSize;
      //objectjson['rowOFFSet'] = offset;
      //objectjson['FlagDelete'] = "N";

      let strjson = JSON.stringify(objectjson);

      console.log(strjson)

      this.ProjectEmpOnPromise = this.httpClient
        .post<ProjectMemberInfo[]>(this.baseurl + "ProjectMember/GetProjectMemberDetail",
          strjson, httpOptions)
        .toPromise()

      return this.ProjectEmpOnPromise;
    }
  }
  //async CountProjectEmpList() {
  //  var auth_token = await this.TokenService.RefreshToken();
  //  if (!!auth_token) {
  //    const httpOptions = {
  //      headers: new HttpHeaders({
  //        'Content-Type': 'application/json',
  //        'Authorization': `Bearer ${auth_token}`
  //      })
  //    };

  //    let offset = (this.currentPageNumber - 1) * environment.PageSize;


  //    let strjson = "{\"EmpCode\": \"" + this.checkUndefinedString(this.txtSearchEmpCode) + "\", " +
  //      //"\"EmpName_TH\": \"" + this.checkUndefinedString(this.txtSearchEmpName_TH) + "\", " +
  //      //"\"CompanyCode\": \"" + this.checkUndefinedString(this.txtSearchCompany) + "\", " +
  //      "\"FlagDelete\": \"N\"" +
  //      "}";


  //    this.httpClient
  //      .post<ProjectMemberInfo[]>(this.baseurl + "ProjectMember/GetCountProjectMember",
  //        strjson, httpOptions)
  //      .toPromise().then(data => {
  //        this.EmpTotal = data
  //      })
  //      .then(() => {
  //        if (this.EmpTotal == 0) {
  //          this.currentPageNumber = 1;
  //        }
  //        this.totalPages = Math.ceil(this.EmpTotal / environment.PageSize)
  //      })
  //  }
  //}

  LoadEmp() {
    this.LoadEmpList()
      .then(
        data => {
          this.empList = data
          this.hidcouchk = this.empList.length.toString();
        }
      )
      .then(() => {
        this.CountEmpList()
      })
  }

  async LoadEmpList(): Promise<EmpInfo[]> {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      let offset = (this.currentPageNumber - 1) * environment.PageSize;
      
      var objectjson = {};
      objectjson['EmpCode'] = this._EmpCode;
      //objectjson['EmpName_TH'] = this.checkUndefinedString(this.txtSearchEmpName_TH);
      //objectjson['CompanyCode'] = this.checkUndefinedString(this.txtSearchCompany);
      //objectjson['rowFetch'] = environment.PageSize;
      //objectjson['rowOFFSet'] = offset;
      //objectjson['FlagDelete'] = "N";

      let strjson = JSON.stringify(objectjson);

      console.log(strjson)

      this.EmpOnPromise = this.httpClient
        .post<EmpInfo[]>(this.baseurl + "Employee/GetEmployeeCriteria",
          strjson, httpOptions)
        .toPromise()

      return this.EmpOnPromise;
    }
  }

  async CountEmpList() {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      let offset = (this.currentPageNumber - 1) * environment.PageSize;


      let strjson = "{\"EmpCode\": \"" + this.checkUndefinedString(this.txtSearchEmpCode) + "\", " +
        "\"EmpName_TH\": \"" + this.checkUndefinedString(this.txtSearchEmpName_TH) + "\", " +
        "\"CompanyCode\": \"" + this.checkUndefinedString(this.txtSearchCompany) + "\", " +
        "\"FlagDelete\": \"N\"" +
        "}";


      this.httpClient
        .post<EmpInfo[]>(this.baseurl + "Employee/GetCountEmployeeCriteria",
          strjson, httpOptions)
        .toPromise().then(data => {
          this.EmpTotal = data
        })
        .then(() => {
          if (this.EmpTotal == 0) {
            this.currentPageNumber = 1;
          }
          this.totalPages = Math.ceil(this.EmpTotal / environment.PageSize)
        })
    }
  }

  async loadDdlTeam() {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {

      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      let strjson = "{\"TeamCode\":\"\" }";

      this.httpClient.post<TeamInfo[]>(this.baseurl + "Team/GetTeamCriteria", strjson, httpOptions)
        .toPromise().then((data) => {
          this.TeamList = data
        })
    }
  }

  async loadDdlRole() {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      let strjson = "{\"RoleCode\":\"\" }";

      this.httpClient.post<RoleInfo[]>(this.baseurl + "Role/GetRole", strjson, httpOptions)
        .toPromise().then((data) => {
          this.RoleList = data
        })
    }
  }

  async loadDdlPosition() {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };
      var objjson = {};
      objjson['FlagActive'] = 'Y'
      let strjson = JSON.stringify(objjson);

      this.httpClient.post<PositionLevelInfo[]>(this.baseurl + "Position/GetPositionLevelList", strjson, httpOptions)
        .toPromise().then((data) => {
          this.PositionList = data
        })
    }
  }

  async loadDdlEmpType() {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };
      let strjson = "{\"LookupType\":\"CONTACTLISTTYPE\" }";

      this.httpClient.post<LookupInfo[]>(this.baseurl + "Lookup/GetLookup", strjson, httpOptions)
        .toPromise().then((data) => {

          this.EmpTypeList = data
        })
    }
  }

  async loadDdlTitle() {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      let strjson = "{\"LookupType\":\"TITLE\" }";

      console.log(strjson);

      this.httpClient.post<LookupInfo[]>(this.baseurl + "Lookup/GetLookup", strjson, httpOptions)
        .toPromise().then((data) => {
          this.TitleList = data
        })
    }
  }

  async loadddlCompany() {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      let strjson = "{\"CompanyCustomerType\":\"55\" }";

      this.httpClient.post<CompanyInfo[]>(this.baseurl + "Company/GetCompany", strjson, httpOptions)
        .toPromise().then((data) => {
          this.CompanyList = data
        })
    }
  }

  async loadGenderList() {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      let strjson = "{\"LookupType\":\"GENDER\" }";

      console.log(strjson);

      this.httpClient.post<LookupInfo[]>(this.baseurl + "Lookup/GetLookup", strjson, httpOptions)
        .toPromise().then((data) => {
          this.GenderList = data
        })
    }
  }

  checkUndefinedString(strInput: string) {
    if (strInput === undefined || strInput === null) {
      strInput = ''
    }
    return strInput

  }

  clearInsertSection() {
    this.hidEmpId = null
    
    //Company Info
    this.ddlCompany = null;
    this.hidEmpType = null;
    this.txtEmpCode = "";
    this.entryDate = null;

    //Personal Info
    this.hidTitleCode = null
    this.txtEmpNickName_TH = ""
    this.txtEmpFName_TH = ""
    this.txtEmpLName_TH = ""
    this.txtEmpFName_EN = "";
    this.txtEmpLName_EN = "";
    this.ddlEmpGender = "";
    this.birthDate = null;
    this.txtEmpEmail = "";
    this.txtEmpTel = "";

    //Role/Position
    this.hidRoleCode = null;
    this.hidPositionCode = 0
    this.hidTeamCode = null
  }

  clearSearchSection() {

    this.txtSearchEmpCode = ""
    this.txtSearchEmpName_TH = ""
    this.txtSearchCompany = ""
    this.isSearchSubmitted = false;
    this.LoadEmp();
  }

  btnClick_cancel() {
    this.clearInsertSection();
    $('#InsertSectionEmp').css('display', 'none'); 
  }

  goToVotes($myParam: string = ''): void {
    //const navigationDetails: string[] = ['/portal'];
    //this.ShowMail = document.getElementById('ShowMail').value
    this.ShowMail = $('#ShowMail').val().toString();
    console.log("this.ShowMail: " + this.ShowMail);
    this.routers.navigateByUrl('/user-password-expire/Y/Y;EmpCode=' + this._EmpCode + ';Email=' + this.ShowMail);

    //if ($myParam.length) {
    //  navigationDetails.push($myParam);
    //}
    //this.routers.navigate(navigationDetails);
  }

  async UpdateEmpCode() {
    //Open both type can generate emp code
    //if (this.hidEmpType == this.internalType) {
      let empcode: string = await this.LoadLatestEmpCode().then(empcode => {
        return empcode.EmpCode;
      }).catch(err => {
        console.log(err);
        return "";
      });

      this.txtEmpCode = empcode;
    //}
  }

  async LoadLatestEmpCode(): Promise<any> {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      var objectjson = {};
      objectjson['CompanyCode'] = this.ddlCompany;
      let strjson = JSON.stringify(objectjson);

      return this.httpClient.post<any>(this.baseurl + "Employee/GetLatestEmployeeCode", strjson, httpOptions)
        .toPromise();
    }
   
  }

  //For Pagination
  LoadListPagination(traget) {
    this.currentPageNumber = traget.currentPageNumber;
    this.totalPages = traget.totalPages;
  }

  OnLoadListFinished(traget = null) {

    if (traget != null) { // check call function from change page or onloadfrist
      this.LoadListPagination(traget);
      this.LoadEmp();
    }

  }

  AuthorizeUser(txtEmpCode) {
    //Open new tab to do OAuth2
    this.getTokenUrl = this.TokenService.GetAccessTokenUrl(txtEmpCode);
    
    window.open(this.getTokenUrl, "_blank");

  }
}
